import { differenceInDays } from 'date-fns';
import { cloudFunctionV2 } from '../api';
import { generatePropertyObject } from '../property';

// Filter functions
export const filterByARVType = (properties, types) => {
	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const flop = element.propertyDetails.compDetails.flop;
		const flip = element.propertyDetails.compDetails.flip;

		if ( types.includes("flop") && flop === true ) {
			newProps.push(element);
		}
		else if ( types.includes("flip") && flip === true && flop === false ) {
			newProps.push(element);
		}
		else if ( types.includes("non-flip") && flop === false && flip === false ) {
			newProps.push(element);
		}
	}
	return newProps;
};

export const filterByDistance = (properties, distance) => {
	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const distanceFrom = element.compDetails.distanceMiles;
		if ( distanceFrom <= distance ) {
			newProps.push(element);
		}
	}
	return newProps;
};

export const filterByCondition = (properties, conditions) => {
	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const propertyCondition = element.compDetails.propertyCondition;
		if ( conditions.includes("all") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("remodelled") && propertyCondition.includes("Recently Remodeled") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("well-maintained") && propertyCondition.includes("Well-Maintained") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("moderate-rehab") && propertyCondition.includes("Moderate Rehab") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("gut-rehab") && propertyCondition.includes("Gut Rehab") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("new-construction") && propertyCondition.includes("Modern Build") ) {
			newProps.push(element);
		}
		else if ( conditions.includes("unknown") && propertyCondition.includes("Unclear") ) {
			newProps.push(element);
		}
	}

	return newProps;
};

export const filterByRecency = (properties, months) => {
	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const listingStatus = element.listingDetails.listingStatus;
		const date = listingStatus === "for_sale" || listingStatus === "pending" ? element.listingDetails.saleListingDate : element.listingDetails.soldListingDate;
		const daysSinceListingOrSale = differenceInDays(new Date(), new Date(date));
		const monthsSinceListingOrSale = daysSinceListingOrSale / 30;
		if ( monthsSinceListingOrSale <= months ) {
			newProps.push(element);
		}
	}
	return newProps;
};

export const filterByType = (properties, types) => {
	if ( types.length === 3 ) {
		return properties;
	}
	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const listingStatus = element.listingDetails.listingStatus;
		if ( types.includes("sold") && listingStatus === "sold" ) {
			newProps.push(element);
		}
		else if ( types.includes("pending") && listingStatus === "pending" ) {
			newProps.push(element);
		}
		else if ( types.includes("for-sale") && listingStatus === "for_sale" ) {
			newProps.push(element);
		}
	}
	return newProps;
};

export const filterBySimilarity = (properties, similarities, subjectProperty) => {
	const bedsPlusMinus = similarities === null ? 100 : similarities.beds === null ? 100 : similarities.beds;
	const bathsPlusMinus = similarities === null ? 100 : similarities.baths === null ? 100 : similarities.baths;
	const sqFootagePlusMinus = similarities === null ? 10000 : similarities.sqft === null ? 10000 : similarities.sqft;
	const yearBuiltPlusMinus = similarities === null ? 10000 : similarities.yearBuilt === null ? 10000 : similarities.yearBuilt;

	const sjBeds = subjectProperty.propertyAttributes.bedrooms;
	const sjBaths = subjectProperty.propertyAttributes.bathrooms;
	const sjSqft = subjectProperty.propertyAttributes.livingSquareFootage;
	const sjYearBuilt = subjectProperty.propertyAttributes.yearBuilt;

	const newProps = [];
	for (let index = 0; index < properties.length; index++) {
		const element = properties[index];
		const compBeds = element.propertyAttributes.bedrooms;
		const compBaths = element.propertyAttributes.bathrooms;
		const compSqft = element.propertyAttributes.livingSquareFootage;
		const compYearBuilt = element.propertyAttributes.yearBuilt;

		const bedsDiff = Math.abs(sjBeds - compBeds);
		const bathsDiff = Math.abs(sjBaths - compBaths);
		const sqftDiff = Math.abs(sjSqft - compSqft);
		const yearBuiltDiff = Math.abs(sjYearBuilt - compYearBuilt);

		if ( bedsDiff <= bedsPlusMinus && bathsDiff <= bathsPlusMinus && sqftDiff <= sqFootagePlusMinus && yearBuiltDiff <= yearBuiltPlusMinus ) {
			newProps.push(element);
		}
	}

	return newProps;
};

// Sort function
export const sortComps = (properties, sortType) => {
	if ( sortType === "group" ) {
		properties.sort((a, b) => a.propertyDetails.compClusterScore.group - b.propertyDetails.compClusterScore.group);
	}
	else if ( sortType === "group-desc" ) {
		properties.sort((a, b) => b.propertyDetails.compClusterScore.group - a.propertyDetails.compClusterScore.group);
	}
	else if ( sortType === "address" ) {
		properties.sort((a, b) => a.propertyDetails.addressDetails.streetAddress.localeCompare(b.propertyDetails.addressDetails.streetAddress));
	}
	else if ( sortType === "address-desc" ) {
		properties.sort((a, b) => b.propertyDetails.addressDetails.streetAddress.localeCompare(a.propertyDetails.addressDetails.streetAddress));
	}
	else if ( sortType === "distance" ) {
		properties.sort((a, b) => a.propertyDetails.compDetails.distanceMiles - b.propertyDetails.compDetails.distanceMiles);
	}
	else if ( sortType === "distance-desc" ) {
		properties.sort((a, b) => b.propertyDetails.compDetails.distanceMiles - a.propertyDetails.compDetails.distanceMiles);
	}
	else if ( sortType === "comp-type" ) {

	}
	else if ( sortType === "comp-type-desc" ) {
		
	}
	else if (sortType === "flip-type") {
		properties.sort((a, b) => {
			const priorityA = a.propertyDetails.compDetails.flip && !a.propertyDetails.compDetails.flop
				? 0
				: a.propertyDetails.compDetails.flop
				? 1
				: 2;

			const priorityB = b.propertyDetails.compDetails.flip && !b.propertyDetails.compDetails.flop
				? 0
				: b.propertyDetails.compDetails.flop
				? 1
				: 2;

			return priorityA - priorityB;
		});
	}
	else if (sortType === "flip-type-desc") {
		properties.sort((a, b) => {
			const priorityA = a.propertyDetails.compDetails.flip && !a.propertyDetails.compDetails.flop
				? 0
				: a.propertyDetails.compDetails.flop
				? 1
				: 2;

			const priorityB = b.propertyDetails.compDetails.flip && !b.propertyDetails.compDetails.flop
				? 0
				: b.propertyDetails.compDetails.flop
				? 1
				: 2;

			return priorityB - priorityA;
		});
	}
	else if ( sortType === "status" ) {
		properties.sort((a, b) => a.propertyDetails.listingDetails.listingStatus.localeCompare(b.propertyDetails.listingDetails.listingStatus));
	}
	else if ( sortType === "status-desc" ) {
		properties.sort((a, b) => b.propertyDetails.listingDetails.listingStatus.localeCompare(a.propertyDetails.listingDetails.listingStatus));
	}
	else if ( sortType === "price" ) {
		properties.sort((a, b) => {
			const priceA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? a.listingDetails.listingPrice : a.listingDetails.soldListingPrice;
			const priceB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? b.listingDetails.listingPrice : b.listingDetails.soldListingPrice;
			return priceA - priceB;
		});
	}
	else if ( sortType === "price-desc" ) {
		properties.sort((a, b) => {
			const priceA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? a.listingDetails.listingPrice : a.listingDetails.soldListingPrice;
			const priceB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? b.listingDetails.listingPrice : b.listingDetails.soldListingPrice;
			return priceB - priceA;
		});
	}
	else if ( sortType === "score" ) {
		properties.sort((a, b) => a.compDetails.overallScore - b.compDetails.overallScore);
	}
	else if ( sortType === "score-desc" ) {
		properties.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
	}
	else if ( sortType === "recency" ) {
		properties.sort((a, b) => {
			const dateA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? new Date(a.listingDetails.saleListingDate) : new Date(a.listingDetails.soldListingDate);
			const dateB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? new Date(b.listingDetails.saleListingDate) : new Date(b.listingDetails.soldListingDate);
			return dateA - dateB;
		});
	}
	else if ( sortType === "recency-desc" ) {
		properties.sort((a, b) => {
			const dateA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? new Date(a.listingDetails.saleListingDate) : new Date(a.listingDetails.soldListingDate);
			const dateB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? new Date(b.listingDetails.saleListingDate) : new Date(b.listingDetails.soldListingDate);
			return dateB - dateA;
		});
	}
	else if ( sortType === "sqft" ) {
		properties.sort((a, b) => a.propertyAttributes.livingSquareFootage - b.propertyAttributes.livingSquareFootage);
	}
	else if ( sortType === "sqft-desc" ) {
		properties.sort((a, b) => b.propertyAttributes.livingSquareFootage - a.propertyAttributes.livingSquareFootage);
	}
	else if ( sortType === "beds" ) {
		properties.sort((a, b) => a.propertyAttributes.bedrooms - b.propertyAttributes.bedrooms);
	}
	else if ( sortType === "beds-desc" ) {
		properties.sort((a, b) => b.propertyAttributes.bedrooms - a.propertyAttributes.bedrooms);
	}
	else if ( sortType === "baths" ) {
		properties.sort((a, b) => a.propertyAttributes.bathrooms - b.propertyAttributes.bathrooms);
	}
	else if ( sortType === "baths-desc" ) {
		properties.sort((a, b) => b.propertyAttributes.bathrooms - a.propertyAttributes.bathrooms);
	}
	else if ( sortType === "year-built" ) {
		properties.sort((a, b) => a.propertyAttributes.yearBuilt - b.propertyAttributes.yearBuilt);
	}
	else if ( sortType === "year-built-desc" ) {
		properties.sort((a, b) => b.propertyAttributes.yearBuilt - a.propertyAttributes.yearBuilt);
	}
	else if ( sortType === "price-per-sqft" ) {
		properties.sort((a, b) => {
			const priceA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? a.listingDetails.listingPrice : a.listingDetails.soldListingPrice;
			const priceB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? b.listingDetails.listingPrice : b.listingDetails.soldListingPrice;
			const sqftA = a.propertyAttributes.livingSquareFootage === null || a.propertyAttributes.livingSquareFootage === 0 ? 0 : priceA / a.propertyAttributes.livingSquareFootage;
			const sqftB = b.propertyAttributes.livingSquareFootage === null || b.propertyAttributes.livingSquareFootage === 0 ? 0 : priceB / b.propertyAttributes.livingSquareFootage;
			return sqftA - sqftB;
		});
	}
	else if ( sortType === "price-per-sqft-desc" ) {
		properties.sort((a, b) => {
			const priceA = a.listingDetails.listingStatus === "for_sale" || a.listingDetails.listingStatus === "pending" ? a.listingDetails.listingPrice : a.listingDetails.soldListingPrice;
			const priceB = b.listingDetails.listingStatus === "for_sale" || b.listingDetails.listingStatus === "pending" ? b.listingDetails.listingPrice : b.listingDetails.soldListingPrice;
			const sqftA = a.propertyAttributes.livingSquareFootage === null || a.propertyAttributes.livingSquareFootage === 0 ? 0 : priceA / a.propertyAttributes.livingSquareFootage;
			const sqftB = b.propertyAttributes.livingSquareFootage === null || b.propertyAttributes.livingSquareFootage === 0 ? 0 : priceB / b.propertyAttributes.livingSquareFootage;
			return sqftB - sqftA;
		});
	}

	return properties;
};

// Comp selection and analysis functions
export const checkConditions = async(comps, setSelectedConditions, allComps, setFilteredComps) => {
	let remodelled = false;
	let wellMaintained = false;
	let moderateRehab = false;
	let gutRehab = false;
	let unknown = false;

	for (let index = 0; index < comps.length; index++) {
		const element = comps[index];
		const propertyCondition = element.compDetails.propertyCondition;
		if ( propertyCondition.includes("Recently Remodeled") ) {
			remodelled = true;
		}
		else if ( propertyCondition.includes("Well-Maintained") ) {
			wellMaintained = true;
		}
		else if ( propertyCondition.includes("Moderate Rehab") ) {
			moderateRehab = true;
		}
		else if ( propertyCondition.includes("Gut Rehab") ) {
			gutRehab = true;
		}
		else if ( propertyCondition.includes("Unclear") ) {
			unknown = true;
		}
	}

	const finalArray = [];
	if ( remodelled === true ) {
		finalArray.push("remodelled");
	}
	if ( wellMaintained === true ) {
		finalArray.push("well-maintained");
	}
	if ( moderateRehab === true ) {
		finalArray.push("moderate-rehab");
	}
	if ( gutRehab === true ) {
		finalArray.push("gut-rehab");
	}
	if ( unknown === true ) {
		finalArray.push("unknown");
	}

	setSelectedConditions(finalArray);

	const newFilteredComps = [];
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		const propertyCondition = element.compDetails.propertyCondition;
		if ( finalArray.includes("remodelled") && propertyCondition.includes("Recently Remodeled") ) {
			newFilteredComps.push(element);
		}
		else if ( finalArray.includes("well-maintained") && propertyCondition.includes("Well-Maintained") ) {
			newFilteredComps.push(element);
		}
		else if ( finalArray.includes("moderate-rehab") && propertyCondition.includes("Moderate Rehab") ) {
			newFilteredComps.push(element);
		}
		else if ( finalArray.includes("gut-rehab") && propertyCondition.includes("Gut Rehab") ) {
			newFilteredComps.push(element);
		}
		else if ( finalArray.includes("unknown") && propertyCondition.includes("Unclear") ) {
			newFilteredComps.push(element);
		}
	}

	newFilteredComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
	setFilteredComps(newFilteredComps);
};

export const startCompSelectionAgent = async(
	allComps,
	subjectProperty,
	companyId,
	propertyId,
	propertyNotes,
	adu,
	pool,
	garage,
	garageSpaces,
	garageType,
	settings,
	anomalyAnswered,
	anomalyData,
	remodelLevel,
	firstName,
	refreshSubjectAnalysis = false
) => {
	const testMode = window.location.hostname === "localhost";
	
	// Detect if running locally (frontend on localhost)
	const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
	const projectId = 'clozers';
	const region = 'us-central1';
	
	// Use local emulator URL if running locally, otherwise use environment variable
	// Note: If emulator is not running, the call will fail - ensure emulator is started with `firebase emulators:start`
	const emulatorUrl = `http://localhost:5001/${projectId}/${region}/arvAgent`;
	const url = isLocalhost ? emulatorUrl : process.env.REACT_APP_ARV_AGENT;

	subjectProperty.listingDetails.aduFlag = adu;
	subjectProperty.propertyAttributes.pool = pool;
	subjectProperty.propertyAttributes.garage = garage;
	
	// Add garage fields at property root level (user-edited fields, like basementSqFootage)
	if (garage === true) {
		if (garageSpaces !== undefined && garageSpaces !== null) {
			subjectProperty.garageSpaces = garageSpaces;
		}
		if (garageType !== undefined && garageType !== null && (garageType === "attached" || garageType === "detached")) {
			subjectProperty.garageType = garageType;
		}
	}

	const params = {
		subjectProperty: subjectProperty,
		allComps: allComps,
		model: "gpt-5-mini",
		companyId: companyId,
		propertyId: propertyId,
		temperature: 1,
		minLocationScore: 0.8,
		propertyNotes: propertyNotes,
		rewriteProvider: "openai",
		rewriteModel: "gpt-4o",
		testMode: testMode,
		// On localhost, source comps from compFetcherV1 instead of the AWS comps
		// passed in `allComps`. arvAgent builds the Subject inline from
		// subjectProperty (needs uniqueIds.zillowId) — guard on it so a
		// subject without a zillowId gracefully falls back to the AWS comps
		// instead of arvAgent returning a hard 400. Production: testMode is
		// always false, so this stays false (no behavior change).
		useCompFetcherV1: testMode && !!subjectProperty?.uniqueIds?.zillowId,
		sms: false,
		anomalyAnswered: anomalyAnswered,
		anomalyRes: anomalyData,
		filterEssential: {
			construction_materials: settings ? settings.constructionMaterials : true,
			pools: settings ? settings.pool : true,
			adu: settings ? settings.adu : true,
			stories: settings ? settings.stories : false,
			bed_bath: false
		},
		remodelLevel: remodelLevel,
		firstName: firstName,
		refreshSubjectAnalysis: refreshSubjectAnalysis
	};
	return new Promise(async resolve => {
		let queryData = await cloudFunctionV2(url, params);
		
		// If running on localhost and emulator call failed, try production as fallback
		if (isLocalhost && queryData.status !== 200 && url === emulatorUrl) {
			console.warn('[startCompSelectionAgent] Emulator call failed, falling back to production URL');
			const productionUrl = process.env.REACT_APP_ARV_AGENT;
			queryData = await cloudFunctionV2(productionUrl, params);
		}
		
		if ( queryData.status === 200 ) {
			const res = {
				status: 200,
				data: queryData
			}
			resolve(res);
		}
		else {
			const res = {
				status: 400,
				error: queryData.error
			};
			resolve(res);
		}
	});
};

export const getBestInitialARVComps = async(allComps) => {
	allComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);

	const initialMinScore = 0.7;
	const atLeastXScore = [];
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		const overallScore = element.compDetails.overallScore;
		if ( overallScore >= initialMinScore ) {
			atLeastXScore.push(element);
		}
	}

	const initialSoldCount = atLeastXScore.filter(e => e.listingDetails.listingStatus === "sold").length;
	if ( initialSoldCount >= 3 ) {
		// We have at least 3 good sold comps
		const bestSoldComps = atLeastXScore.filter(e => e.listingDetails.listingStatus === "sold").slice(0, 3);
		for (let index = 0; index < atLeastXScore.length; index++) {
			const element = atLeastXScore[index];
			if ( bestSoldComps.length >= 5 ) {
				break;
			}

			const zpid = element.uniqueIds.zillowId;
			const zpidIndex = bestSoldComps.findIndex(e => e.uniqueIds.zillowId === zpid);
			if ( zpidIndex !== -1 ) {
				continue;
			}
			bestSoldComps.push(element);
		}

		bestSoldComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
		return bestSoldComps;
	}
	else {

		// We do NOT have at least 3 good sold comps
		const minLocationScore = 0.8;
		const bestSoldLocationComps = [];
		for (let index = 0; index < allComps.length; index++) {
			const element = allComps[index];
			const status = element.listingDetails.listingStatus;
			if ( status !== "sold" ) {
				continue;
			}
			const zpid = element.uniqueIds.zillowId;
			const zpidIndex = atLeastXScore.findIndex(e => e.uniqueIds.zillowId === zpid);
			if ( zpidIndex !== -1 ) {
				continue;
			}
			const locationScore = element.compDetails.locationScore;
			if ( locationScore >= minLocationScore ) {
				bestSoldLocationComps.push(element);
			}
		}
		bestSoldLocationComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
		const neededSoldComps = 3 - initialSoldCount;
		const bestSoldComps = bestSoldLocationComps.slice(0, neededSoldComps);
		for (let index = 0; index < atLeastXScore.length; index++) {
			const element = atLeastXScore[index];
			if ( bestSoldComps.length >= 5 ) {
				break;
			}

			const zpid = element.uniqueIds.zillowId;
			const zpidIndex = bestSoldComps.findIndex(e => e.uniqueIds.zillowId === zpid);
			if ( zpidIndex !== -1 ) {
				continue;
			}
			bestSoldComps.push(element);
		}
		
		bestSoldComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
		return bestSoldComps;
	}
};

export const getBestARVComps = async(allComps) => {
	const newFilteredComps = [];
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		const propertyCondition = element.compDetails.propertyCondition;
		if ( 
			propertyCondition === "Recently Remodeled" ||
			propertyCondition === "Well-Maintained – Traditional" ||
			propertyCondition === "Well-Maintained – Contemporary"
		) {
			newFilteredComps.push(element);
		}
	}

	const newBestComps = await getBestInitialARVComps(newFilteredComps);
	return newBestComps;
};

export const getAllARVComps = async(allComps) => {
	const allCompsArray = [];
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		const overallScore = element.compDetails.overallScore;
		if ( overallScore < 0.5 ) {
			continue;
		}
		const propertyCondition = element.compDetails.propertyCondition;
		if (
			propertyCondition === "Recently Remodeled" ||
			propertyCondition === "Well-Maintained – Traditional" ||
			propertyCondition === "Well-Maintained – Contemporary"
		) {
			allCompsArray.push(element);
		}
	}
	return allCompsArray;
};

export const minifyComps = async(allComps) => {
	const newArray = [];
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		const newObject = await generatePropertyObject(element);
		newArray.push(newObject);
	}
	return newArray;
};

export const maxifyComps = async(zpids, allComps) => {
	const newArray = [];
	for (let index = 0; index < zpids.length; index++) {
		const zpid = zpids[index];
		const zpidIndex = allComps.findIndex(e => e.uniqueIds.zillowId === zpid);
		if ( zpidIndex !== -1 ) {
			const element = allComps[zpidIndex];
			newArray.push(element);
		}
	}
	return newArray;
};

export const getNextSoldComps = async(allComps, bestComps) => {
	const nextBestSoldComps = [];
	const compLimit = 3;

	allComps.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
	for (let index = 0; index < allComps.length; index++) {
		const element = allComps[index];
		if ( nextBestSoldComps.length >= compLimit ) {
			break;
		}

		const zpid = element.uniqueIds.zillowId;
		const zpidIndex = bestComps.findIndex(e => e.uniqueIds.zillowId === zpid);
		if ( zpidIndex !== -1 ) {
			continue;
		}

		const listingStatus = element.listingDetails.listingStatus;
		if ( listingStatus !== "sold" ) {
			continue;
		}

		nextBestSoldComps.push(element);
	}

	return nextBestSoldComps;
};

export const generateSelectedCompsArray = async(fullSelectedComps, selectedComps, value) => {
	const selectedCompSubmission = [];
	for (let index = 0; index < fullSelectedComps.length; index++) {
		const element = fullSelectedComps[index];
		const zpid = element.uniqueIds.zillowId;
		const selectedCompIndex = selectedComps.findIndex(e => e.zpid === zpid);
		if ( selectedCompIndex === -1 ) {
			continue;
		}
		const selectedCompType = selectedComps[selectedCompIndex].type;
		if ( selectedCompType === value ) {
			const newObject = await generatePropertyObject(element);
			selectedCompSubmission.push(newObject);
		}
	}
	return selectedCompSubmission;
};

